import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ShelfArticle from "./pages/ShelfArticle";
import HowItWorksPage from "./pages/HowItWorksPage";
import FeaturesPage from "./pages/FeaturesPage";
import ShelvesPage from "./pages/ShelvesPage";
import CirclesPage from "./pages/CirclesPage";
import ReadingGuidesPage from "./pages/ReadingGuidesPage";
import ReadingGuideArticle from "./pages/ReadingGuideArticle";
import BookBlogPage from "./pages/BookBlogPage";
import BookBlogArticle from "./pages/BookBlogArticle";
import HelpCenterPage from "./pages/HelpCenterPage";
import AboutPage from "./pages/AboutPage";
import JournalPage from "./pages/JournalPage";
import CareersPage from "./pages/CareersPage";
import PressKitPage from "./pages/PressKitPage";
import { ThemeProvider } from "./context/ThemeContext";
import { LegalModalsProvider } from "./context/LegalModalsContext";

function App() {
  return (
    <ThemeProvider>
      <LegalModalsProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/shelves" element={<ShelvesPage />} />
            <Route path="/circles" element={<CirclesPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/reading-guides" element={<ReadingGuidesPage />} />
            <Route
              path="/reading-guides/:slug"
              element={<ReadingGuideArticle />}
            />
            <Route path="/book-blog" element={<BookBlogPage />} />
            <Route path="/book-blog/:slug" element={<BookBlogArticle />} />
            <Route path="/help-center" element={<HelpCenterPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/journal" element={<JournalPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/press-kit" element={<PressKitPage />} />
            <Route path="/shelf/:slug" element={<ShelfArticle />} />
          </Routes>
        </BrowserRouter>
      </div>
      </LegalModalsProvider>
    </ThemeProvider>
  );
}

export default App;
